var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SiteSearchAPIConnector from "@elastic/search-ui-site-search-connector";
import { SearchProvider as ElasticSearchProvider, WithSearch } from "@elastic/react-search-ui";
import DiscourseSearch from "./discourse";
import { getResultsByKey } from "./utils";
var apiConnector = new SiteSearchAPIConnector({
    engineKey: "BZL_aEiLAebVKkcm3eFr",
    documentType: "page",
});
var config = {
    apiConnector: apiConnector,
    initialState: {
        resultsPerPage: 100,
    },
    searchQuery: {
        result_fields: {
            title: {
                snippet: {
                    size: 100,
                    fallback: true,
                },
            },
            url: {
                raw: {},
            },
            description: {
                snippet: {
                    size: 100,
                    fallback: true,
                },
            },
        },
    },
    alwaysSearchOnInitialLoad: false,
};
var mapContextToProps = function (_a) {
    var searchTerm = _a.searchTerm, setSearchTerm = _a.setSearchTerm, results = _a.results, reset = _a.reset;
    return ({
        searchTerm: searchTerm,
        setSearchTerm: setSearchTerm,
        results: __assign(__assign({}, getResultsByKey(results)), { discourse: [] }),
        reset: reset,
    });
};
var SearchProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(ElasticSearchProvider, { config: config },
        React.createElement(WithSearch, { mapContextToProps: mapContextToProps }, function (props) { return React.createElement(DiscourseSearch, __assign({}, props), children); })));
};
export default SearchProvider;
